<!-- Advertencia de ambiente. Va antes del toolbar y no dentro, para que quede
     arriba de todo y no compita con el resto de la barra. -->
<div
  *ngIf="avisoAmbiente"
  class="w-full px-6 py-1.5 flex items-center gap-2 text-xs font-medium
         bg-amber-100 text-amber-900 border-b border-amber-300">
  <mat-icon class="!text-base !w-4 !h-4 flex-shrink-0">warning</mat-icon>
  <span>{{ avisoAmbiente }}</span>
</div>

<div
  [class.container]="isVerticalLayout$ | async"
  class="toolbar text-default w-full px-6 flex items-center">
  <button
    (click)="openSidenav()"
    [class.hidden]="isDesktop$ | async"
    mat-icon-button
    type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>

  <a
    *ngIf="isVerticalLayout$ | async"
    [routerLink]="['/']"
    class="ltr:mr-4 rtl:ml-4 flex items-center">
    <img
      alt="Invertus"
      class="h-12 w-auto select-none bg-transparent"
      src="assets/img/logo/logo-small.png" />
    <h1
      [class.hidden]="isDesktop$ | async"
      class="text-2xl font-bold tracking-wide ltr:pl-4 rtl:pr-4 m-0 select-none">
      {{ title$ | async }}
    </h1>
  </a>

  <button
    *ngIf="isHorizontalLayout$ | async"
    [class.hidden]="!(isDesktop$ | async)"
    [matMenuTriggerFor]="addNewMenu"
    color="primary"
    mat-flat-button
    type="button">
    Add New
  </button>

  <mat-menu
    #addNewMenu="matMenu"
    [overlapTrigger]="false"
    xPosition="after"
    yPosition="below">
    <button mat-menu-item>
      <mat-icon svgIcon="mat:person_add"></mat-icon>
      <span>Add Contact</span>
    </button>

    <button mat-menu-item>
      <mat-icon svgIcon="mat:done_all"></mat-icon>
      <span>Add Task</span>
    </button>

    <button mat-menu-item>
      <mat-icon svgIcon="mat:assignment_turned_in"></mat-icon>
      <span>Add Project</span>
    </button>

    <button [matMenuTriggerFor]="documentMenu" mat-menu-item>
      <mat-icon svgIcon="mat:ballot"></mat-icon>
      <span>Add Document</span>
    </button>
  </mat-menu>

  <mat-menu #documentMenu="matMenu">
    <button mat-menu-item>
      <mat-icon svgIcon="mat:description"></mat-icon>
      <span>Add Quote</span>
    </button>

    <button mat-menu-item>
      <mat-icon svgIcon="mat:assignment"></mat-icon>
      <span>Add Invoice</span>
    </button>

    <button mat-menu-item>
      <mat-icon svgIcon="mat:receipt"></mat-icon>
      <span>Add Receipt</span>
    </button>
  </mat-menu>

  <div #megaMenuOriginRef class="ltr:ml-2 rtl:mr-2">
    <button
      (click)="openMegaMenu(megaMenuOriginRef)"
      *ngIf="isHorizontalLayout$ | async"
      [class.hidden]="!(isDesktop$ | async)"
      [ngClass]="{ 'bg-primary-600/10': megaMenuOpen$ | async }"
      color="primary"
      mat-button
      type="button">
      <span>Mega Menu</span>
      <mat-icon class="icon-sm" svgIcon="mat:arrow_drop_down"></mat-icon>
    </button>
  </div>

  <div
    *ngIf="(isVerticalLayout$ | async) && (isNavbarInToolbar$ | async)"
    [class.hidden]="!(isDesktop$ | async)"
    class="px-6 flex-none flex items-center">
    <vex-navigation-item
      *ngFor="let item of navigationItems$ | async"
      [item]="item"></vex-navigation-item>
  </div>

  <span class="flex-1"></span>

  <div class="-mx-1 flex items-center">
    <!-- Postulaciones es de Selección (Invering). El endpoint exige
         `gestion_humana`: sin esta guarda, a quien no lo tenga le llegaba un 403
         en cada sondeo y el interceptor global le mostraba un error cada minuto,
         por una campana que nunca iba a tener nada que mostrarle. -->
    <div class="px-1" *ngIf="tieneGestionHumana">
      <inv-alertas-postulaciones></inv-alertas-postulaciones>
    </div>
    <!-- La campana de obras consulta /tasks/mis-alertas, que ahora exige el módulo
         `proyectos`. Sin esta guarda, a quien no lo tenga le llegaría un 403 en cada
         ciclo de sondeo y el interceptor global le mostraría un error cada vez, por
         una campana que además nunca tendría nada que mostrarle. -->
    <div class="px-1" *ngIf="tieneProyectos">
      <inv-alertas-tareas></inv-alertas-tareas>
    </div>
    <!-- Leads es comercial (Infinitus). Mismo criterio: `/leads/mis-alertas`
         exige el módulo `leads`. -->
    <div class="px-1" *ngIf="tieneLeads">
      <inv-alertas-leads></inv-alertas-leads>
    </div>

    <div *ngIf="userVisible$ | async" class="px-1">
      <vex-toolbar-user></vex-toolbar-user>
    </div>
  </div>
</div>

<vex-navigation
  *ngIf="(isVerticalLayout$ | async) && (isNavbarBelowToolbar$ | async)"
  [class.hidden]="!(isDesktop$ | async)"></vex-navigation>
